class HelperService 
{
    constructor($, _, initConfigProvider, $http, $urlMatcherFactory, $state) {
        this.$ = $;
        this._ = _;
        this.state = $state;
        this.apiBaseUrl = initConfigProvider.apiBaseUrl;
        this.http = $http;
        this.urlMatcherFactory = $urlMatcherFactory;
    }

    getConflictCategories() {
        return this._getListByEnumName('ConflictCategory', true);
    }

    getEmploymentOptions() {
        return this._getListByEnumName('EmploymentOption');
    }

    getDisclosureStatusOptions() {
        return this._getListByEnumName('DisclosureStatus'); 
    }

    getDisclosureTypeOptions() {
        return this._getListByEnumName('DisclosureType'); 
    }

    getManagementStrategies() {
        return this._getListByEnumName('ManagementStrategyType');
    }

    getDisclosureSearchFilters() {
        return this._getListByEnumName('DisclosureFilterOptions'); 
    }

    getDisclosureStatusFiltersForAdminSearch() {
        return this._getListByEnumName('DisclosureStatus', true, 'IsuAdminCanAccessStatus'); 
    }

    getDisclosureStatusFilters() {
        return this._getListByEnumName('DisclosureStatus', true, 'DiscloserCanFilterByDisclosureStatus');
    }

    getDistinctFaculties() {
        return this._getDistinctFaculties();
    }

    getDistinctSchools() {
        return this._getDistinctSchools();
    }

    createUrlMatcherForStates(state) {
        let urlMatcherForStateMaps = [];
        for (let stateObj of state.get()) {
            let urlMatcherForState = this.urlMatcherFactory.compile(stateObj.url);
            urlMatcherForStateMaps.push({
                matcher: urlMatcherForState,
                state: stateObj
            });
        }
        return urlMatcherForStateMaps;
    }

    getMatchingStateByUrl(matcherStates, url) {
        for (let urlMatcherState of matcherStates){
            let urlMatch = urlMatcherState.matcher.exec(url);
            if (urlMatch) {
                return {
                    state: urlMatcherState.state,
                    match: urlMatch
                };
            }
        }
        return null;
    }

    hasValidRoleForAction(userRole, menuOption) {
        return !menuOption || !menuOption.role || this._.intersection(userRole, menuOption.role).length > 0;
    }

    getMenuByState(menu, state) {
        let menuFound = this._getMenuByState(menu, state);
        if (!menuFound) {
            let routeState = this.state.get(state);
            if (routeState.vparent) {
                menuFound = this._getMenuByState(menu, routeState.vparent);
            }
        }
        return menuFound;
    }
    
    _getMenuByState(menu, state) {
        for (let option of menu) {
            if (option.state === state) {
                return option;
            }   
            if (option.sub) {
                let menuFound = this._getMenuByState(option.sub, state);
                if (menuFound) {
                    return menuFound;
                }
            }
        }
        return undefined;
    }

    _getDistinctFaculties() {
        return this.http({
            method: 'GET',
            headers: { 'Accept': 'text/json' },
            url: `${this.apiBaseUrl}/api/faculties`
        }).then((response) => {
            if (response.status === 200) {
                return {
                    data: response.data,
                    error: ''
                }
            } else {
                if (response.data && response.data.error) {
                    return {
                        data: null,
                        error: response.data.error
                    };
                }
            }
            return {
                data: null,
                error: 'helper service error'
            };
        }).catch((error) => {
            console.log(error);
            return {
                data: null,
                error: error
            };
        });
    }

    _getDistinctSchoolsByFaculty(facultyName) {
        return this.http({
            method: 'GET',
            headers: { 'Accept': 'text/json' },
            url: `${this.apiBaseUrl}/api/faculty/${facultyName}`
        }).then((response) => {
            if (response.status === 200) {
                return {
                    data: response.data,
                    error: ''
                }
            } else {
                if (response.data && response.data.error) {
                    return {
                        data: null,
                        error: response.data.error
                    };
                }
            }
            return {
                data: null,
                error: 'helper service error'
            };
        }).catch((error) => {
            console.log(error);
            return {
                data: null,
                error: error
            };
        });
    }

    _getDistinctSchools() {
        return this.http({
            method: 'GET',
            headers: { 'Accept': 'text/json' },
            url: `${this.apiBaseUrl}/api/schools`
        }).then((response) => {
            if (response.status === 200) {
                return {
                    data: response.data,
                    error: ''
                }
            } else {
                if (response.data && response.data.error) {
                    return {
                        data: null,
                        error: response.data.error
                    };
                }
            }
            return {
                data: null,
                error: 'helper service error'
            };
        }).catch((error) => {
            console.log(error);
            return {
                data: null,
                error: error
            };
        });
    }

    _getListByEnumName(enumName, orderEnums = false, enumValueFilter = null) {
        return this.http({
            method: 'GET',
            headers: { 'Accept': 'text/json' },
            url: enumValueFilter ? `${this.apiBaseUrl}/api/enums/${enumName}/${enumValueFilter}` : `${this.apiBaseUrl}/api/enums/${enumName}`
    }).then((response) => {
            if (response.status === 200) {
                return {
                    data: orderEnums ? this._.orderBy(response.data, ['description']) : response.data,
                    error: ''
                }
            } else {
                if (response.data && response.data.error) {
                    return {
                        data: null,
                        error: response.data.error
                    };
                } 
            }
            return {
                data: null,
                error: 'helper service error'
            };
        }).catch((error) => {
            console.log(error);
            return  {
                data: null,
                error: error
            };
        });
    }
}

HelperService.$inject = ['$', '_', 'initConfigProvider', '$http', '$urlMatcherFactory', '$state'];

export default HelperService;


// WEBPACK FOOTER //
// ./app/services/helper.service.js